<template>
  <div class="marketing-email-form-verify-item">
    <i class="mdi mdi-check-circle marketing-email-form-verify-item-icon"></i>

    <div class="marketing-email-form-verify-item-body">
      <p class="marketing-email-form-verify-item-body-label">{{ label }}</p>

      <div class="marketing-email-form-verify-item-body-value">
        <p class="marketing-email-form-verify-item-body-value-item">{{ valueText }}</p>
        <i v-if="editable"
           v-tooltip="$t('message.generics.message.edit')"
           class="mdi mdi-square-edit-outline pointer marketing-email-form-verify-item-body-value-icon"
           @click="emitEdit"></i>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: undefined,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    valueText() {
      return this.value ? this.value : this.$t('message.marketingGenerics.message.valueNotFilled');
    },
  },

  mounted() {},

  methods: {
    emitEdit() {
      this.$emit("edit");
    },
  },

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-email-form-verify-item {
  display: flex;
  border-bottom: 1px solid #c8c8c8;
  margin-bottom: 15px;

  .marketing-email-form-verify-item-icon {
    color: $primary;
    font-size: 30px;
    margin-right: 15px;
    margin-left: 50px;
  }

  .marketing-email-form-verify-item-body {
    .marketing-email-form-verify-item-body-label {
      margin: 0;
      color: #707070;
      font-weight: 600;
      font-size: 14px;
    }

    .marketing-email-form-verify-item-body-value {
      display: flex;
      align-items: center;
      font-size: 14px;

      .marketing-email-form-verify-item-body-value-item {
        margin: 0;
        font-size: 14px;
        margin-right: 5px;
      }

      .marketing-email-form-verify-item-body-value-icon {
        color: #707070;
      }
    }
  }
}
</style>

